export function selectInspections() {
    return (state) => state.inspections.current?.inspections;
}

export function selectInspection() {
    return (state) => state.inspections.current?.inspection;
}

export function selectInspectionItems() {
    return (state) => state.inspections.current?.inspectionItems;
}